import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Search } from 'lucide-react';
import { getPaymentTypes, createPaymentMethod } from '../../services/p2pService';
import { useToast } from '../../context/ToastContext';

export default function AddPaymentMethod() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [types, setTypes] = useState<any[]>([]);
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState<any>(null);
  const [fields, setFields] = useState<Record<string,string>>({});
  const [loading, setLoading] = useState(false);

  useEffect(()=>{ getPaymentTypes().then(setTypes).catch(()=>{}); },[]);

  const filtered = types.filter(t=>t.name.toLowerCase().includes(search.toLowerCase()));

  const handleField = (f:string, v:string) => setFields(prev=>({...prev,[f]:v}));

  const submit = async () => {
    if (!selected) return;
    if (!fields.accountName?.trim()) { toast('Account name is required','error'); return; }
    setLoading(true);
    try {
      await createPaymentMethod({ methodType:selected.name, accountName:fields.accountName, accountNumber:fields.accountNumber, phoneNumber:fields.phoneNumber, extraFields:fields });
      toast('Payment method added!','success');
      navigate(-1);
    } catch(e:any){ toast(e.message,'error'); }
    setLoading(false);
  };

  if (selected) return (
    <div style={{ background:'var(--p2p-bg-primary)', minHeight:'100vh' }}>
      <div className="p2p-header">
        <button className="p2p-back-btn" onClick={()=>setSelected(null)}><ArrowLeft size={20}/>{selected.name}</button>
      </div>
      <div style={{ padding:16, display:'flex', flexDirection:'column', gap:16 }}>
        {selected.fields.map((f:string)=>(
          <div key={f}>
            <div style={{ fontSize:13, color:'var(--p2p-text-muted)', marginBottom:8, textTransform:'capitalize' }}>{f.replace(/([A-Z])/g,' $1')}</div>
            <input className="p2p-input" placeholder={f} value={fields[f]??''} onChange={e=>handleField(f,e.target.value)} />
          </div>
        ))}
        <button className="p2p-btn-yellow" disabled={loading} onClick={submit}>{loading?'Saving...':'Confirm'}</button>
      </div>
    </div>
  );

  return (
    <div style={{ background:'var(--p2p-bg-primary)', minHeight:'100vh' }}>
      <div className="p2p-header">
        <button className="p2p-back-btn" onClick={()=>navigate(-1)}><ArrowLeft size={20}/>Add Payment Method</button>
      </div>
      <div style={{ padding:'12px 16px', borderBottom:'1px solid var(--p2p-border-default)' }}>
        <div style={{ position:'relative' }}>
          <Search size={16} style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'var(--p2p-text-muted)' }}/>
          <input className="p2p-input" style={{ paddingLeft:36 }} placeholder="Search payment method..." value={search} onChange={e=>setSearch(e.target.value)} />
        </div>
      </div>
      <div>{filtered.map(t=>(
        <div key={t.name} style={{ display:'flex', alignItems:'center', gap:12, padding:'14px 16px', borderBottom:'1px solid var(--p2p-border-default)', cursor:'pointer' }} onClick={()=>{ setSelected(t); setFields({}); }}>
          <span className="p2p-pm-dot" style={{ background:t.color, width:10, height:10 }}/>
          <span style={{ fontSize:14, color:'var(--p2p-text-primary)' }}>{t.name}</span>
        </div>
      ))}</div>
    </div>
  );
}
